export default __webpack_public_path__ + "static/pfsense-a6ccfcb5e031bbeafc82303a0f96f07f.png";